module.exports = {"540324100":"丁青镇","540324101":"尺犊镇","540324200":"木塔乡","540324201":"布塔乡","540324202":"巴达乡","540324203":"甘岩乡","540324204":"嘎塔乡","540324205":"色扎乡","540324206":"协雄乡","540324207":"桑多乡","540324208":"当堆乡","540324209":"沙贡乡","540324210":"觉恩乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540324.json
// module id = 2513
// module chunks = 0